"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerModule = void 0;
const base_1 = require("./base");
class ContainerModule extends base_1.SurveyModule {
    constructor({ modules = [], ...rest } = {}) {
        super(rest);
        this._type = "container";
        this.modules = modules;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                id: this.id,
                modules: this.modules.map((mod) => mod.toBuilderConfig()),
                noBorder: this.noBorder,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                builderConfigModule.tag = this.tag;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            const surveyConfigModule = {
                id: this.id,
                modules: this.modules.flatMap((mod) => mod.toSurveyConfig()),
                noBorder: this.noBorder,
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                surveyConfigModule.tag = this.tag;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        return undefined;
    }
}
exports.ContainerModule = ContainerModule;
//# sourceMappingURL=Container.js.map